// The company's own day and clock in the browser (31 October 2026): every day
// the web sends and every "Today" it shows, for every role. The zone is the
// one /auth/me serves (`timeZone`, the company's reminder policy's, else
// London's), set here by `lib/session.js` and when Reminders saves a new one.
// The rules are shared/company-day.js's, the iPhone's `CompanyClock`'s twin.
//
// Never the browser's own calendar: in Auckland that was tomorrow for half of
// every London day, and Record payment refused a payment received "today" as
// a day to come. What already happened, said to the reader ("Today at 9am" on
// an Activity line), stays on the reader's clock (`formatActivityTimestamp`).
// test/rule-company-day.test.mjs fails on a browser-day read anywhere else.
import { DEFAULT_TIME_ZONE, clockInZone, dayInZone, knownTimeZone, zonedInstant } from "../../../shared/company-day.js";

let zone = DEFAULT_TIME_ZONE;

/** The open company's zone becomes `timeZone` (London for none or one the browser doesn't know). */
export function setCompanyTimeZone(timeZone) {
  zone = knownTimeZone(timeZone);
}

export function companyTimeZone() {
  return zone;
}

/** Today in the company's calendar, "YYYY-MM-DD". */
export function companyToday(now = new Date()) {
  return dayInZone(now, zone);
}

/** The company's day an instant falls on, "YYYY-MM-DD", or "". */
export function companyDayOf(instant) {
  return dayInZone(instant, zone);
}

/** An instant on the company's clock, `{ date, minute }`, or null. */
export function companyClock(instant) {
  return clockInZone(instant, zone);
}

/** The instant a time of the company's work is: a day and minutes into it on its clock. */
export function companyInstant(day, minutes) {
  return new Date(zonedInstant(day, minutes, zone));
}
